import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { IControlProps, MapProps } from '.';
import { Password } from 'primereact/password';
import styles from './index.module.scss';

interface IProps extends IControlProps<string> { 
  storage?: IDataStorage;
  /** estilo para el panel de información de contraseña */
  panelClassName?: string
}

interface IState extends IControlProps<string> {
  storage?: IDataStorage;
  panelClassName?: string;
  
  /** Indica el mensaje de error si es que existe */
  validError?: string;
}

class Index extends React.Component<IProps, IState> {
  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name, () => this.change(this.state.value));
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.panelClassName !== s?.panelClassName) res.panelClassName = p.panelClassName;
    return MapProps(res, p, s);
  }

  render() {
    const { validError } = this.state;
    
    return (
      <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
        {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>}
        <div className={`${styles.addons} p-inputgroup`}>
          {this.state.required && 
            <span className={`p-inputgroup-addon ${(validError && styles.erroraddon) ?? ''}`}>
              <i className="pi pi-exclamation-circle" />
            </span>
          }
          <Password
            defaultValue={this.state.value}
            placeholder={this.state.placeholder}
            disabled={this.state.disabled}
            tooltip={validError}
            tooltipOptions={{ position: 'bottom' }}
            onChange={e => this.change((e.target as any).value)}
            onBlur={e => this.change((e.target as any).value)}
            className={`w-100 p-inputtext ${styles.ctrl} ${validError && 'p-error'}`}
            weakLabel="Contraseña débil"
            mediumLabel="Seguridad media"
            strongLabel="Contraseña fuerte"
            panelClassName={this.state.panelClassName}
          />
        </div>
        {validError && <span className={styles.errordesc}>{validError}</span>}
      </div>
    );
  }
  
  change = (value?: string) : string | undefined => {
    const { onChange, validate, isValid } = this.props;

    let error = this.validate(value);
    if (validate) error = validate(value);
    if (isValid) isValid(!error, error);
    
    this.setState({ validError: error });

    if (onChange) onChange(value, error);

    return error;
  }

  private validate = (value?: string) : string | undefined => {
    const { required } = this.state;
    if (required && (value?.length ?? 0) < 1) return 'campo requerido';
    return undefined;
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
